// import React, { useState, useEffect, useMemo } from 'react';
// import { 
//     Spinner, Card, CardBody, Typography, IconButton, Tooltip, Select, Option 
// } from "@material-tailwind/react";
// import Axios from 'axios';
// import Main from './Main';
// import { transformarFechaTramiteSimple } from '../Helpers/fechas';
// import Swal from 'sweetalert2';
// import { ArrowDownTrayIcon, FunnelIcon } from "@heroicons/react/24/solid";
// import { getToken } from '../Helpers/auth-helpers';

// export default function Recibos({ usuario }) {

//     const [datos, setDatos] = useState([]);
//     const [buscandoDatos, setBuscandoDatos] = useState(false);
    
//     const [anioSeleccionado, setAnioSeleccionado] = useState(
//         new Date().getFullYear().toString()
//     );

//     const [contribuyenteSeleccionado, setContribuyenteSeleccionado] = useState("todos");

//     useEffect(() => {
//         obtenerDatos();
//     }, []);

//     const obtenerDatos = async () => {
//         setBuscandoDatos(true);
//         try {
//             const { data } = await Axios.get(
//                 `/api/tablasgenerales/recibos/ministro/${usuario.id_obrero}`
//             );
//             setDatos(data);
//         } catch (err) {
//             console.error("Error al obtener recibos:", err);
//         } finally {
//             setBuscandoDatos(false);
//         }
//     };

//     // Opciones disponibles según datos y año
//     const opcionesFiltros = useMemo(() => {

//         const anios = [...new Set(
//             datos.map(d => d.year.toString())
//         )].sort((a, b) => b - a);

//         const contribuyentes = [...new Set(
//             datos
//                 .filter(d => d.year.toString() === anioSeleccionado)
//                 .map(d => d.contribuyente?.trim())
//                 .filter(Boolean)
//         )].sort();

//         return { anios, contribuyentes };

//     }, [datos, anioSeleccionado]);

//     // 👇 Cuando cambia el año, reseteamos contribuyente
//     useEffect(() => {

//         setContribuyenteSeleccionado("todos");

//     }, [anioSeleccionado]);

//     const datosFiltrados = useMemo(() => {

//         return datos.filter(d => {

//             const coincideAnio =
//                 d.year.toString() === anioSeleccionado;

//             const coincideContribuyente =
//                 contribuyenteSeleccionado === "todos" ||
//                 d.contribuyente?.trim() === contribuyenteSeleccionado;

//             return coincideAnio && coincideContribuyente;

//         });

//     }, [datos, anioSeleccionado, contribuyenteSeleccionado]);

//     const contribuyentesAMostrar = useMemo(() => {
//         return [
//             ...new Set(
//                 datosFiltrados
//                     .map(d => d.contribuyente?.trim())
//                     .filter(Boolean)
//             )
//         ];
//     }, [datosFiltrados]);

//     const imprimirRecibo = (item) => {
//         const token = getToken();
//         const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/${token}/${item.id_ingreso}`;
//         window.open(url, '_blank');
//     };

//     if (buscandoDatos)
//         return (
//             <Main center alinear>
//                 <Spinner className="h-12 w-12" />
//             </Main>
//         );

//     return (
//         <Main>
//             <div className="container mx-auto px-4 pb-10">

//                 <Typography
//                     variant="h4"
//                     color="blue-gray"
//                     className="text-center my-6"
//                 >
//                     Mis Recibos
//                 </Typography>

//                 <Card className="w-full lg:w-[80%] m-auto px-6 py-8 mb-6 shadow-sm border border-blue-gray-100">

//                     <div className="flex items-center gap-2 mb-6 text-blue-gray-800 border-b border-gray-100 pb-2">
//                         <FunnelIcon className="h-5 w-5 text-[#05AFF4]" />
//                         <Typography className="font-bold">
//                             Panel de Búsqueda
//                         </Typography>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

//                         {/* Año */}
//                         <div className="flex flex-col select-personal-data">
//                             <Typography
//                                 variant="small"
//                                 color="blue-gray"
//                                 className="mb-2 font-medium"
//                             >
//                                 Año fiscal
//                             </Typography>

//                             <Select
//                                 value={anioSeleccionado}
//                                 onChange={(val) => setAnioSeleccionado(val)}
//                                 className="!border-t-blue-gray-200 focus:!border-t-gray-900"
//                                 labelProps={{ className: "before:content-none after:content-none" }}
//                             >
//                                 {opcionesFiltros.anios.map(a => (
//                                     <Option key={a} value={a}>
//                                         {a}
//                                     </Option>
//                                 ))}
//                             </Select>
//                         </div>

//                         {/* Contribuyente */}
//                         <div className="flex flex-col select-personal-data">
//                             <Typography
//                                 variant="small"
//                                 color="blue-gray"
//                                 className="mb-2 font-medium"
//                             >
//                                 Contribuyente / Iglesia
//                             </Typography>

//                             <Select
//                                 value={contribuyenteSeleccionado}
//                                 onChange={(val) => setContribuyenteSeleccionado(val)}
//                                 className="!border-t-blue-gray-200 focus:!border-t-gray-900"
//                                 labelProps={{ className: "before:content-none after:content-none" }}
//                             >
//                                 <Option value="todos">
//                                     Todos los contribuyentes
//                                 </Option>

//                                 {opcionesFiltros.contribuyentes.map(c => (
//                                     <Option key={c} value={c}>
//                                         {c}
//                                     </Option>
//                                 ))}
//                             </Select>
//                         </div>

//                     </div>
//                 </Card>

//                 {/* RESULTADOS */}
//                 <div className="w-full lg:w-[80%] mx-auto">

//                     {contribuyentesAMostrar.length === 0 ? (

//                         <Typography className="text-center py-10 text-gray-500 italic">
//                             No hay recibos para este criterio.
//                         </Typography>

//                     ) : (

//                         contribuyentesAMostrar.map(contribuyente => {

//                             const recibos = datosFiltrados.filter(
//                                 d => d.contribuyente?.trim() === contribuyente
//                             );

//                             return (
//                                 <div key={contribuyente} className="mb-8">

//                                     <div className="mb-2 px-1">
//                                         <Typography
//                                             variant="h6"
//                                             className="uppercase text-[10px] tracking-widest opacity-60"
//                                         >
//                                             Entidad Pagadora
//                                         </Typography>

//                                         <Typography
//                                             variant="h5"
//                                             color="blue-gray"
//                                             className="font-bold"
//                                         >
//                                             {contribuyente}
//                                         </Typography>
//                                     </div>

//                                     <Card className="shadow-sm border border-gray-200 overflow-hidden">
//                                         <CardBody className="p-0 overflow-x-auto">

//                                             <table className="w-full min-w-max table-auto text-left">

//                                                 <thead>
//                                                     <tr className="bg-gray-50">
//                                                         {['Comprobante', 'Fecha', 'Monto', 'PDF'].map((head) => (
//                                                             <th
//                                                                 key={head}
//                                                                 className="py-3 px-4 border-b border-gray-100"
//                                                             >
//                                                                 <Typography
//                                                                     variant="small"
//                                                                     className="font-bold text-blue-gray-400 uppercase text-[11px]"
//                                                                 >
//                                                                     {head}
//                                                                 </Typography>
//                                                             </th>
//                                                         ))}
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody>
//                                                     {recibos.map((item) => (
//                                                         <tr
//                                                             key={item.id_ingreso}
//                                                             className="hover:bg-blue-gray-50/50"
//                                                         >
//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small" className="font-medium">
//                                                                     {item.comprobante}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small">
//                                                                     {transformarFechaTramiteSimple(item.fecha)}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small" className="font-bold">
//                                                                     $ {item.monto.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <IconButton
//                                                                     variant="text"
//                                                                     color="red"
//                                                                     size="sm"
//                                                                     onClick={() => imprimirRecibo(item)}
//                                                                 >
//                                                                     <ArrowDownTrayIcon className="h-5 w-5" />
//                                                                 </IconButton>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>

//                                             </table>

//                                         </CardBody>
//                                     </Card>
//                                 </div>
//                             );

//                         })

//                     )}

//                 </div>
//             </div>
//         </Main>
//     );
// }

// import React, { useState, useEffect, useMemo } from 'react';
// import { 
//     Spinner, Card, CardBody, Typography, IconButton
// } from "@material-tailwind/react";
// import Axios from 'axios';
// import Main from './Main';
// import { transformarFechaTramiteSimple } from '../Helpers/fechas';
// import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
// import { getToken } from '../Helpers/auth-helpers';

// export default function Recibos({ usuario }) {

//     const [datos, setDatos] = useState([]);
//     const [buscandoDatos, setBuscandoDatos] = useState(false);
//     const [contribuyentes, setContribuyentes] = useState([]);
//     const [contribuyenteSeleccionado, setContribuyenteSeleccionado] = useState("todos");

//     useEffect(() => {
//         obtenerDatos();
//     }, []);

// useEffect(() => {

//     if (!datos.length) {
//         setContribuyentes([]);
//         return;
//     }

//     const mapa = new Map();

//     for (const d of datos) {

//         const nombre = d.contribuyente?.trim();

//         if (!nombre) continue;

//         if (!mapa.has(nombre)) {
//             mapa.set(nombre, d.id); // usamos el id que ya inventaste
//         }
//     }

//     const lista = Array.from(mapa.entries()).map(
//         ([nombre, id]) => ({ id, nombre })
//     );

//     setContribuyentes(lista);

// }, [datos]);


//     const obtenerDatos = async () => {
//         setBuscandoDatos(true);
//         try {
//             const { data } = await Axios.get(
//                 `/api/tablasgenerales/recibos/ministro/${usuario.id_obrero}`
//             );
//             setDatos(data.map((info,index)=>{
//                 return {
//                     ...info,
//                     id:index+1
//                 }
//             }));
//         } catch (err) {
//             console.error("Error al obtener recibos:", err);
//         } finally {
//             setBuscandoDatos(false);
//         }
//     };

//     const contribuyentesAMostrar = useMemo(() => {
//         return [
//             ...new Set(
//                 datos
//                     .map(d => d.contribuyente?.trim())
//                     .filter(Boolean)
//             )
//         ];
//     }, [datos]);

//     const imprimirRecibo = (item) => {
//         const token = getToken();
//         const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/${token}/${item.id_ingreso}`;
//         window.open(url, '_blank');
//     };

//     if (buscandoDatos) {
//         return (
//             <Main center alinear>
//                 <Spinner className="h-12 w-12" />
//             </Main>
//         );
//     }

//     return (
//         <Main>
//             <div className="container mx-auto px-4 pb-10">
//                 <Typography
//                     variant="h4"
//                     color="blue-gray"
//                     className="text-center my-6"
//                 >
//                     Mis Recibos
//                 </Typography>

//                 {/* RESULTADOS */}
//                 <div className="w-full lg:w-[80%] mx-auto">

//                     {contribuyentesAMostrar.length === 0 ? (

//                         <Typography className="text-center py-10 text-gray-500 italic">
//                             No hay recibos para mostrar.
//                         </Typography>

//                     ) : (

//                         contribuyentesAMostrar.map(contribuyente => {

//                             const recibos = datos.filter(
//                                 d => d.contribuyente?.trim() === contribuyente
//                             );

//                             return (
//                                 <div key={contribuyente} className="mb-8">

//                                     <div className="mb-2 px-1">
//                                         <Typography
//                                             variant="h6"
//                                             className="uppercase text-[10px] tracking-widest opacity-60"
//                                         >
//                                             Entidad Pagadora
//                                         </Typography>

//                                         <Typography
//                                             variant="h5"
//                                             color="blue-gray"
//                                             className="font-bold"
//                                         >
//                                             {contribuyente}
//                                         </Typography>
//                                     </div>

//                                     <Card className="shadow-sm border border-gray-200 overflow-hidden">
//                                         <CardBody className="p-0 overflow-x-auto">

//                                             <table className="w-full min-w-max table-auto text-left">

//                                                 <thead>
//                                                     <tr className="bg-gray-50">
//                                                         {['Comprobante', 'Fecha', 'Monto', 'PDF'].map((head) => (
//                                                             <th
//                                                                 key={head}
//                                                                 className="py-3 px-4 border-b border-gray-100"
//                                                             >
//                                                                 <Typography
//                                                                     variant="small"
//                                                                     className="font-bold text-blue-gray-400 uppercase text-[11px]"
//                                                                 >
//                                                                     {head}
//                                                                 </Typography>
//                                                             </th>
//                                                         ))}
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody>
//                                                     {recibos.map((item) => (
//                                                         <tr
//                                                             key={item.id_ingreso}
//                                                             className="hover:bg-blue-gray-50/50"
//                                                         >
//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small" className="font-medium">
//                                                                     {item.comprobante}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small">
//                                                                     {transformarFechaTramiteSimple(item.fecha)}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small" className="font-bold">
//                                                                     $ {item.monto.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <IconButton
//                                                                     variant="text"
//                                                                     color="red"
//                                                                     size="sm"
//                                                                     onClick={() => imprimirRecibo(item)}
//                                                                 >
//                                                                     <ArrowDownTrayIcon className="h-5 w-5" />
//                                                                 </IconButton>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>

//                                             </table>

//                                         </CardBody>
//                                     </Card>
//                                 </div>
//                             );

//                         })

//                     )}

//                 </div>
//             </div>
//         </Main>
//     );
// }

// import React, { useState, useEffect, useMemo } from 'react';
// import { 
//     Spinner,
//     Card,
//     CardBody,
//     Typography,
//     IconButton,
//     Select,
//     Option
// } from "@material-tailwind/react";
// import Axios from 'axios';
// import Main from './Main';
// import { transformarFechaTramiteSimple } from '../Helpers/fechas';
// import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
// import { getToken } from '../Helpers/auth-helpers';

// export default function Recibos({ usuario }) {

//     const [datos, setDatos] = useState([]);
//     const [buscandoDatos, setBuscandoDatos] = useState(false);

//     const [contribuyentes, setContribuyentes] = useState([]);
//     const [contribuyenteSeleccionado, setContribuyenteSeleccionado] = useState("todos");

//     useEffect(() => {
//         obtenerDatos();
//     }, []);

//     const obtenerDatos = async () => {
//         setBuscandoDatos(true);
//         try {
//             const { data } = await Axios.get(
//                 `/api/tablasgenerales/recibos/ministro/${usuario.id_obrero}`
//             );

//             const datosConId = data.map((info, index) => ({
//                 ...info,
//                 id: index + 1
//             }));

//             setDatos(datosConId);

//         } catch (err) {
//             console.error("Error al obtener recibos:", err);
//         } finally {
//             setBuscandoDatos(false);
//         }
//     };

//     // Construimos la lista de contribuyentes una sola vez a partir de datos
//     useEffect(() => {

//         if (!datos.length) {
//             setContribuyentes([]);
//             return;
//         }

//         const mapa = new Map();

//         for (const d of datos) {

//             const nombre = d.contribuyente?.trim();

//             if (!nombre) continue;

//             if (!mapa.has(nombre)) {
//                 mapa.set(nombre, d.id); // usamos el id ya inventado
//             }
//         }

//         const lista = Array.from(mapa.entries()).map(
//             ([nombre, id]) => ({ id, nombre })
//         );

//         setContribuyentes(lista);

//     }, [datos]);

//     const contribuyentesAMostrar = useMemo(() => {

//         if (contribuyenteSeleccionado === "todos") {
//             return contribuyentes.map(c => c.nombre);
//         }

//         const encontrado = contribuyentes.find(
//             c => c.id === Number(contribuyenteSeleccionado)
//         );

//         return encontrado ? [encontrado.nombre] : [];

//     }, [contribuyentes, contribuyenteSeleccionado]);

//     const imprimirRecibo = (item) => {
//         const token = getToken();
//         const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/${token}/${item.id_ingreso}`;
//         window.open(url, '_blank');
//     };

//     if (buscandoDatos) {
//         return (
//             <Main center alinear>
//                 <Spinner className="h-12 w-12" />
//             </Main>
//         );
//     }

//     return (
//         <Main>
//             <div className="container mx-auto px-4 pb-10">

//                 <Typography
//                     variant="h4"
//                     color="blue-gray"
//                     className="text-center my-6"
//                 >
//                     Mis Recibos
//                 </Typography>

//                 {/* Selector de contribuyentes */}
//                 <Card className="w-full lg:w-[80%] m-auto px-6 py-6 mb-6 shadow-sm border border-blue-gray-100">

//                     <Typography
//                         variant="small"
//                         color="blue-gray"
//                         className="mb-2 font-medium"
//                     >
//                         Contribuyente
//                     </Typography>

//                     <Select
//                         value={contribuyenteSeleccionado}
//                         onChange={(val) => setContribuyenteSeleccionado(val)}
//                         labelProps={{ className: "before:content-none after:content-none" }}
//                     >
//                         <Option value="todos">
//                             Todos los contribuyentes
//                         </Option>

//                         {contribuyentes.map(c => (
//                             <Option key={c.id} value={String(c.id)}>
//                                 {c.nombre}
//                             </Option>
//                         ))}
//                     </Select>

//                 </Card>

//                 {/* RESULTADOS */}
//                 <div className="w-full lg:w-[80%] mx-auto">

//                     {contribuyentesAMostrar.length === 0 ? (

//                         <Typography className="text-center py-10 text-gray-500 italic">
//                             No hay recibos para mostrar.
//                         </Typography>

//                     ) : (

//                         contribuyentesAMostrar.map(contribuyente => {

//                             const recibos = datos.filter(
//                                 d => d.contribuyente?.trim() === contribuyente
//                             );

//                             return (
//                                 <div key={contribuyente} className="mb-8">

//                                     <div className="mb-2 px-1">
//                                         <Typography
//                                             variant="h6"
//                                             className="uppercase text-[10px] tracking-widest opacity-60"
//                                         >
//                                             Entidad Pagadora
//                                         </Typography>

//                                         <Typography
//                                             variant="h5"
//                                             color="blue-gray"
//                                             className="font-bold"
//                                         >
//                                             {contribuyente}
//                                         </Typography>
//                                     </div>

//                                     <Card className="shadow-sm border border-gray-200 overflow-hidden">
//                                         <CardBody className="p-0 overflow-x-auto">

//                                             <table className="w-full min-w-max table-auto text-left">

//                                                 <thead>
//                                                     <tr className="bg-gray-50">
//                                                         {['Comprobante', 'Fecha', 'Monto', 'PDF'].map((head) => (
//                                                             <th
//                                                                 key={head}
//                                                                 className="py-3 px-4 border-b border-gray-100"
//                                                             >
//                                                                 <Typography
//                                                                     variant="small"
//                                                                     className="font-bold text-blue-gray-400 uppercase text-[11px]"
//                                                                 >
//                                                                     {head}
//                                                                 </Typography>
//                                                             </th>
//                                                         ))}
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody>
//                                                     {recibos.map((item) => (
//                                                         <tr
//                                                             key={item.id_ingreso}
//                                                             className="hover:bg-blue-gray-50/50"
//                                                         >
//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small" className="font-medium">
//                                                                     {item.comprobante}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small">
//                                                                     {transformarFechaTramiteSimple(item.fecha)}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <Typography variant="small" className="font-bold">
//                                                                     $ {item.monto.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
//                                                                 </Typography>
//                                                             </td>

//                                                             <td className="py-2 px-4 border-b border-gray-50">
//                                                                 <IconButton
//                                                                     variant="text"
//                                                                     color="red"
//                                                                     size="sm"
//                                                                     onClick={() => imprimirRecibo(item)}
//                                                                 >
//                                                                     <ArrowDownTrayIcon className="h-5 w-5" />
//                                                                 </IconButton>
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>

//                                             </table>

//                                         </CardBody>
//                                     </Card>
//                                 </div>
//                             );

//                         })

//                     )}

//                 </div>
//             </div>
//         </Main>
//     );
// }

// import React, { useState, useEffect } from 'react';
// import { 
//     Spinner, Card, CardBody, Typography, IconButton 
// } from "@material-tailwind/react";
// import Axios from 'axios';
// import Main from './Main';
// import { transformarFechaTramiteSimple } from '../Helpers/fechas';
// import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
// import { getToken } from '../Helpers/auth-helpers';

// export default function Recibos({ usuario }) {
//     const [datos, setDatos] = useState([]);
//     const [buscandoDatos, setBuscandoDatos] = useState(false);
    
//     const [listaContribuyentes, setListaContribuyentes] = useState([]);
//     const [contribuyenteSeleccionado, setContribuyenteSeleccionado] = useState("todos");

//     useEffect(() => {
//         obtenerDatos();
//     }, []);

//     const obtenerDatos = async () => {
//         setBuscandoDatos(true);
//         try {
//             const { data } = await Axios.get(`/api/tablasgenerales/recibos/ministro/${usuario.id_obrero}`);
            
//             const mapaAux = new Map();
//             const procesados = data.map((item, index) => {
//                 const nombreLimpio = item.contribuyente?.trim() || "Sin Identificar";
//                 const idFijo = String(index + 1);

//                 if (!mapaAux.has(nombreLimpio)) {
//                     mapaAux.set(nombreLimpio, idFijo);
//                 }
//                 return { ...item, contribuyente: nombreLimpio, id_frontend: mapaAux.get(nombreLimpio) };
//             });

//             const paraSelector = Array.from(mapaAux, ([nombre, id]) => ({ id, nombre }))
//                                       .sort((a, b) => a.nombre.localeCompare(b.nombre));

//             setDatos(procesados);
//             setListaContribuyentes(paraSelector);
//         } catch (err) {
//             console.error("Error:", err);
//         } finally {
//             setBuscandoDatos(false);
//         }
//     };

//     // Lógica de filtrado manual
//     const nombresARenderizar = contribuyenteSeleccionado === "todos" 
//         ? listaContribuyentes.map(c => c.nombre)
//         : [listaContribuyentes.find(c => c.id === contribuyenteSeleccionado)?.nombre].filter(Boolean);

//     const imprimirRecibo = (item) => {
//         const token = getToken();
//         const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/${token}/${item.id_ingreso}`;
//         window.open(url, '_blank');
//     };

//     if (buscandoDatos) return <Main center alinear><Spinner className="h-12 w-12" /></Main>;

//     return (
//         <Main>
//             <div className="container mx-auto px-4 pb-10">
//                 <Typography variant="h4" color="blue-gray" className="text-center my-6 font-bold">
//                     Mis Recibos
//                 </Typography>

//                 {/* SELECTOR NATIVO DE HTML CON ESTILO TAILWIND */}
//                 <Card className="w-full lg:w-[80%] m-auto px-6 py-6 mb-6 shadow-sm border border-blue-gray-100">
//                     <label className="block mb-2 text-sm font-medium text-blue-gray-900">
//                         Seleccionar Contribuyente
//                     </label>
//                     <select
//                         value={contribuyenteSeleccionado}
//                         onChange={(e) => setContribuyenteSeleccionado(e.target.value)}
//                         className="bg-white border border-blue-gray-200 text-blue-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 outline-none transition-all"
//                     >
//                         <option value="todos">Todos los contribuyentes</option>
//                         {listaContribuyentes.map(c => (
//                             <option key={c.id} value={c.id}>
//                                 {c.nombre}
//                             </option>
//                         ))}
//                     </select>
//                 </Card>

//                 {/* TABLAS DE RESULTADOS */}
//                 <div className="w-full lg:w-[80%] mx-auto">
//                     {nombresARenderizar.map(nombre => {
//                         const recibos = datos.filter(d => d.contribuyente === nombre);
//                         return (
//                             <div key={`seccion-${nombre}`} className="mb-10">
//                                 <Typography variant="h5" color="blue-gray" className="mb-3 font-bold px-1 uppercase text-sm tracking-wide">
//                                     {nombre}
//                                 </Typography>

//                                 <Card className="shadow-sm border border-gray-200 overflow-hidden">
//                                     <CardBody className="p-0 overflow-x-auto">
//                                         <table className="w-full min-w-max table-auto text-left">
//                                             <thead>
//                                                 <tr className="bg-gray-50 border-b border-gray-100">
//                                                     <th className="py-3 px-4 text-[11px] font-bold text-blue-gray-400 uppercase">Comprobante</th>
//                                                     <th className="py-3 px-4 text-[11px] font-bold text-blue-gray-400 uppercase">Fecha</th>
//                                                     <th className="py-3 px-4 text-[11px] font-bold text-blue-gray-400 uppercase">Monto</th>
//                                                     <th className="py-3 px-4 text-[11px] font-bold text-blue-gray-400 uppercase text-center font-serif">PDF</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {recibos.map((item) => (
//                                                     <tr key={item.id_ingreso} className="hover:bg-blue-gray-50/50 transition-colors">
//                                                         <td className="py-2 px-4 border-b border-gray-50 text-sm font-medium text-blue-gray-800">{item.comprobante}</td>
//                                                         <td className="py-2 px-4 border-b border-gray-50 text-sm">{transformarFechaTramiteSimple(item.fecha)}</td>
//                                                         <td className="py-2 px-4 border-b border-gray-50 text-sm font-bold text-gray-900">
//                                                             $ {item.monto.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
//                                                         </td>
//                                                         <td className="py-2 px-4 border-b border-gray-50 text-center">
//                                                             <IconButton variant="text" color="red" size="sm" onClick={() => imprimirRecibo(item)}>
//                                                                 <ArrowDownTrayIcon className="h-5 w-5" />
//                                                             </IconButton>
//                                                         </td>
//                                                     </tr>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </CardBody>
//                                 </Card>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>
//         </Main>
//     );
// }

import React, { useState, useEffect, useMemo } from 'react';
import { 
    Spinner, Card, CardBody, Typography, IconButton 
} from "@material-tailwind/react";
import Axios from 'axios';
import Main from './Main';
import { transformarFechaTramiteSimple } from '../Helpers/fechas';
import { ArrowDownTrayIcon, FunnelIcon } from "@heroicons/react/24/solid";
import { getToken } from '../Helpers/auth-helpers';

export default function Recibos({ usuario }) {
    const [datos, setDatos] = useState({ contribuyentes: [], ingresos: [] });
    const [buscandoDatos, setBuscandoDatos] = useState(false);
    
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear().toString());
    const [contribuyenteSeleccionado, setContribuyenteSeleccionado] = useState("todos");

    const anioActual = new Date().getFullYear();
    const anioAnterior = anioActual - 1;

    useEffect(() => {
        obtenerDatos();
    }, []);

    const obtenerDatos = async () => {
        setBuscandoDatos(true);
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/recibos/ministro/${usuario.id_obrero}`);
            setDatos(data);
            
            // Sincronización de año inicial
            const anios = [...new Set(data.ingresos.map(i => i.year.toString()))];
            if (anios.length > 0 && !anios.includes(anioSeleccionado)) {
                setAnioSeleccionado(anios[0]);
            }
        } catch (err) {
            console.error("Error:", err);
        } finally {
            setBuscandoDatos(false);
        }
    };

    const aniosDisponibles = useMemo(() => {
        return [...new Set(datos.ingresos.map(i => i.year.toString()))].sort((a, b) => b - a);
    }, [datos.ingresos]);

    const nombresAFiltrar = useMemo(() => {
        const porAnio = datos.ingresos.filter(d => d.year.toString() === anioSeleccionado);
        if (contribuyenteSeleccionado === "todos") {
            return [...new Set(porAnio.map(d => d.contribuyente))];
        }
        const encontrado = datos.contribuyentes.find(c => c.id === contribuyenteSeleccionado);
        return encontrado ? [encontrado.nombre] : [];
    }, [datos, anioSeleccionado, contribuyenteSeleccionado]);

    const imprimirRecibo = (item) => {
        const token = getToken();
        const url = `${process.env.REACT_APP_API_UAD_BASE}/documentos/recibo/false/${token}/${item.id_ingreso}/false`;
        window.open(url, '_blank');
    };

    if (buscandoDatos) return <Main center alinear><Spinner className="h-12 w-12" /></Main>;

    return (
        <Main>
            <div className="container mx-auto px-4 pb-10">
                <Typography variant="h4" color="blue-gray" className="text-center my-6 font-bold tracking-tight">
                    Recibos de diezmos ({`${anioActual} - ${anioAnterior}`})
                </Typography>

                <Card className="w-full lg:w-[80%] m-auto px-6 py-8 mb-8 shadow-sm border border-blue-gray-100">
                    <div className="flex items-center gap-2 mb-6 text-blue-gray-800 border-b border-gray-100 pb-2">
                        <FunnelIcon className="h-5 w-5 text-[#05AFF4]" />
                        <Typography className="font-bold">Panel de Búsqueda</Typography>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* SELECTOR DE AÑO NATIVO ESTILIZADO */}
                        <div className="flex flex-col">
                            <Typography variant="small" color="blue-gray" className="mb-2 font-medium">Año fiscal</Typography>
                            <select 
                                value={anioSeleccionado}
                                onChange={(e) => setAnioSeleccionado(e.target.value)}
                                className="w-full h-10 px-3 py-2 text-sm bg-transparent border rounded-md border-blue-gray-200 focus:border-gray-900 outline-none transition-all cursor-pointer text-blue-gray-700"
                            >
                                {aniosDisponibles.map(a => <option key={a} value={a}>{a}</option>)}
                            </select>
                        </div>

                        {/* SELECTOR DE CONTRIBUYENTE NATIVO ESTILIZADO */}
                        <div className="flex flex-col">
                            <Typography variant="small" color="blue-gray" className="mb-2 font-medium">Contribuyente / Iglesia</Typography>
                            <select 
                                value={contribuyenteSeleccionado}
                                onChange={(e) => setContribuyenteSeleccionado(e.target.value)}
                                className="w-full h-10 px-3 py-2 text-sm bg-transparent border rounded-md border-blue-gray-200 focus:border-gray-900 outline-none transition-all cursor-pointer text-blue-gray-700"
                            >
                                <option value="todos">Todos los contribuyentes</option>
                                {datos.contribuyentes.map(c => (
                                    <option key={c.id} value={c.id}>{c.nombre}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </Card>

                    <div className="w-full lg:w-[80%] mx-auto">
                        {nombresAFiltrar.length === 0 ? (
                            <div className="text-center py-12 bg-gray-50 rounded-xl border border-dashed border-gray-300">
                                <Typography className="italic text-gray-500">No hay recibos para el año {anioSeleccionado}.</Typography>
                            </div>
                        ) : (
                            nombresAFiltrar.map(nombre => {
                                const recibos = datos.ingresos.filter(d => d.contribuyente === nombre && d.year.toString() === anioSeleccionado);
                                return (
                                    <div key={nombre} className="mb-10 animate-fade-in">
                                        <div className="mb-2 px-1">
                                            <Typography variant="h6" className="uppercase text-[10px] tracking-widest opacity-60">Contribuyente</Typography>
                                            <Typography variant="h5" color="blue-gray" className="font-bold">{nombre}</Typography>
                                        </div>
                                        <Card className="shadow-sm border border-gray-200 overflow-hidden">
                                            <CardBody className="p-0 overflow-x-auto">
                                                <table className="w-full table-fixed text-left"> 
                                                    <thead>
                                                        <tr className="bg-gray-50 border-b border-gray-100">

                                                            {/* Comprobante */}
                                                            <th className="py-3 px-4 text-[11px] font-bold text-blue-gray-400 uppercase w-48">
                                                                Comprobante
                                                            </th>

                                                            {/* Fecha */}
                                                            <th className="py-3 px-4 text-[11px] font-bold text-blue-gray-400 uppercase w-36 text-center">
                                                                Fecha
                                                            </th>

                                                            {/* Monto */}
                                                            <th className="py-3 px-4 text-[11px] font-bold text-blue-gray-400 uppercase w-44 text-right">
                                                                Monto
                                                            </th>

                                                            {/* Acción */}
                                                            <th className="w-16 border-b border-gray-100"></th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {recibos.map((item) => (
                                                            <tr
                                                                key={item.id_ingreso}
                                                                className="hover:bg-blue-gray-50/50 transition-colors"
                                                            >

                                                                {/* Comprobante */}
                                                                <td className="py-2 px-4 border-b border-gray-50 text-sm font-medium
                                                                            w-48 max-w-[12rem] truncate text-blue-gray-800">
                                                                    {item.comprobante}
                                                                </td>

                                                                {/* Fecha */}
                                                                <td className="py-2 px-4 border-b border-gray-50 text-sm text-center text-blue-gray-600">
                                                                    {transformarFechaTramiteSimple(item.fecha)}
                                                                </td>

                                                                {/* Monto */}
                                                                <td className="py-2 px-4 border-b border-gray-50 text-sm font-bold text-right text-gray-900">
                                                                    $ {item.monto.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                                                                </td>

                                                                {/* Acción */}
                                                                <td className="py-2 border-b border-gray-50">
                                                                    <div className="flex justify-center items-center">
                                                                        <IconButton 
                                                                            variant="text" 
                                                                            color="blue" 
                                                                            size="sm" 
                                                                            className="rounded-full hover:bg-red-50"
                                                                            onClick={() => imprimirRecibo(item)}
                                                                        >
                                                                            <ArrowDownTrayIcon className="h-5 w-5" />
                                                                        </IconButton>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </CardBody>
                                        </Card>
                                    </div>
                                );
                            })
                        )}
                    </div>
            </div>
        </Main>
    );
}